import { ComponentProps, FC } from 'react';
import { GenericInput } from './GenericInput';
import { RegisterOptions } from 'react-hook-form';
import { INPUT_NUMBER_MAX_MESSAGE, INPUT_NUMBER_MIN_MESSAGE } from '../../../constants/form';
import { NumberFormat } from '../../../config/NumberFormat';

const ONLY_NUMBER_REGEX = '^[0-9]*$';

type Props = {
  max?: number;
  min?: number;
} & ComponentProps<typeof GenericInput>;

export const InputNumber: FC<Props> = ({ max, min, ...otherProps }) => {
  const validationOptions = getValidationOptions(max, min);

  return <GenericInput registerOptions={validationOptions} onBeforeInput={validateNumber} {...otherProps} />;
};

InputNumber.defaultProps = {
  charactersType: 'dígitos',
};

function getValidationOptions(max?: number, min?: number): RegisterOptions {
  const registerOptions: RegisterOptions = {};

  if (max !== undefined)
    registerOptions.max = {
      value: max,
      message: `${INPUT_NUMBER_MAX_MESSAGE} ${NumberFormat.formatNumber(max)}`,
    };

  if (min !== undefined)
    registerOptions.min = {
      value: min,
      message: `${INPUT_NUMBER_MIN_MESSAGE} ${NumberFormat.formatNumber(min)}`,
    };

  return registerOptions;
}

function validateNumber(event: any) {
  if (event == null || event.data == null) return;

  const value = event.data;

  if (!value.match(ONLY_NUMBER_REGEX)) event.preventDefault();
}
